import { loadStripe, Stripe } from '@stripe/stripe-js';
import { useEffect } from 'react';
import {
	useCreateSessionForSubscriptionPaymentMutation,
	useFetchStripePublishableKey2Query,
} from './graphql.generated';

// We only need to load this once.
let _stripePromise: Promise<Stripe | null> | undefined | null = undefined;

export const useStripePromise = (priceItemId: string | undefined) => {
	const {
		data: pubkData,
		loading: pubkLoading,
		error: pubkError,
	} = useFetchStripePublishableKey2Query({
		fetchPolicy: 'cache-first',
	});
	const [fetchSessionKey, { data: sessionData, loading: sessionLoading, error: sessionError }] =
		useCreateSessionForSubscriptionPaymentMutation();

	/** Fetch the publishable key. It lives on the server for easy update/revoke */
	useEffect(() => {
		if (pubkData?.stripePublishableKey) {
			_stripePromise = loadStripe(pubkData.stripePublishableKey);
		}
	}, [pubkData?.stripePublishableKey]);

	/** Create a Stripe Session, which returns a secret session key for user to complete the transaction */
	useEffect(() => {
		if (priceItemId) {
			fetchSessionKey({
				variables: {
					lineItem: { priceId: priceItemId, quantity: 1 },
				},
			});
		}
	}, [fetchSessionKey, priceItemId]);

	if (pubkError || sessionError) {
		console.error(pubkError || sessionError);
	}

	return {
		stripePromise: _stripePromise,
		clientSecret: sessionData?.createSessionForSubscriptionPayment?.clientSecret,
		loading: pubkLoading || sessionLoading,
		error: pubkError || sessionError,
	};
};
